import {fetchGet, fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueDancers = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancers",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancersPayout = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancers/payout",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancerTipsAndDancesTotal = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/all",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancerTipsAndDancesHistory = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/all/history",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancerTips = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/tips",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const findVenueDancerTipsHistory = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/tips/history",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const processDancerTips = (
    venueId,
    dancerId,
    payoutPinNumber,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        payoutPinNumber: payoutPinNumber
    };

    fetchPost(
        uri + "/venue/" + venueId + "/dancer/" + dancerId + "/tips",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};
